__turbopack_context__.v({
  "bundle-unit-container": "course-body-content-module-scss-module__El1ffW__bundle-unit-container",
  "container": "course-body-content-module-scss-module__El1ffW__container",
});
